export default __webpack_public_path__ + "static/media/trustpilot.984d4361.svg";